export default {
  "Autocomplete.all_number_selected": "Wybrano wszystkie {number}",
  "Autocomplete.all_number": "Wszystkie ({number})",
  "Card.toggle_content": "przełącz zawartość",
  "Chip.remove": "usunąć",
  "DatePicker.next": "Następny",
  "DatePicker.previous": "Poprzedni",
  "Pagination.first": "Pierwszy",
  "Pagination.go_to_page_number": "Przejdź do strony {index}",
  "Pagination.go_to_page": "Przejdź do strony {label}",
  "Pagination.last": "ostatni",
  "Pagination.next": "Następny",
  "Pagination.previous": "poprzedni",
  "Table.actions": "Akcje tabeli",
  "Table.add_column": "Dodaj kolumnę",
  "Table.clear_selection": "Wyczyść wybór",
  "Table.filter": "Filtr",
  "Table.hide": "Ukrywać",
  "Table.more_actions": "Więcej akcji",
  "Table.move_left": "Przesuń w lewo",
  "Table.move_right": "Ruch w prawo",
  "Table.pagination": "Paginacja tabeli",
  "Table.pagination_loading": "Ładowanie elementów sterujących paginacją tabeli",
  "Table.per_page": "Na stronę",
  "Table.position_zero": "0 z {total}",
  "Table.position": "{start}-{end} z {total}",
  "Table.search": "Szukaj",
  "Table.select_all": "Zaznacz wszystko",
  "Table.select_all_n": "Zaznacz wszystkie {count}",
  "Table.select_row": "Wybierz {row}",
  "Table.sort_ascending": "Sortuj rosnąco",
  "Table.sort_descending": "Sortuj malejąco",
  "TextInput.clear_labelled_input": "Wyczyść {label}",
  "Ui.clear_all": "Wyczyść wszystko",
  "Ui.close": "Zamknąć",
  "Ui.loading": "Ładowanie",
  "Ui.no_results": "Brak wyników",
  "Ui.number_selected": "Wybrano {number}",
  "Ui.remove": "Usunąć",
  "Ui.select_all": "Zaznacz wszystko",
  "Ui.show_more": "+ {count} Więcej"
}
